import styled from 'styled-components';

export const Container = styled.div`
  font-family: 'Roboto', sans-serif;
  gap: 24px;
  padding: 32px 24px;
  border: 1px solid ${(props) => props.theme.$conlicitacao_banner_border};
  border-radius: 8px;
  background: linear-gradient(
    180deg,
    ${(props) => props.theme.$conlicitacao_banner_gradient_start} 0%,
    ${(props) => props.theme.$conlicitacao_banner_gradient_end} 100%
  );

  .banner-logo {
    flex-shrink: 0;
    width: 198px;
    height: 32px;
  }

  .banner-text {
    flex: 1 0 0;
    margin: 0;
    color: ${(props) => props.theme.$white};
    font-size: 20px;
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: -0.4px;
    text-align: center;

    @media (min-width: 1200px) {
      font-size: 32px;
      letter-spacing: -0.64px;
    }
  }

  .banner-button {
    flex-shrink: 0;
    padding: 16px;
    border: none;
    border-radius: 4px;
    background-color: ${(props) => props.theme.$conlicitacao_banner_button_bg};
    color: ${(props) => props.theme.$conlicitacao_banner_button_text};
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2;
    letter-spacing: -0.32px;
    white-space: nowrap;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.9;
    }
  }
`;
